import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Clock } from "lucide-react";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import { Reveal } from "@/components/site/motion";
import api from "@/lib/api";

const Blog = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/blog", { params: { published: true } })
      .then((r) => setPosts(r.data))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="blog-page" className="bg-sand min-h-screen">
      <Navbar />
      <main className="pt-36 md:pt-44 pb-24 md:pb-36">
        <div className="mx-auto max-w-[1400px] px-5 md:px-10">
          <Reveal className="max-w-3xl mb-16">
            <p className="text-sm uppercase tracking-[0.25em] text-terracotta mb-4">Resources & Insights</p>
            <h1 className="font-serif text-5xl md:text-7xl text-forest tracking-tighter leading-[0.98]">
              Guidance for the road to recovery
            </h1>
            <p className="mt-6 text-ink2 text-lg leading-relaxed">
              Honest, compassionate articles on addiction, mental health and healing — written to help you
              and your loved ones take the next step with confidence.
            </p>
          </Reveal>

          {loading ? (
            <p className="text-ink2">Loading articles…</p>
          ) : (
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {posts.map((p, i) => (
                <Reveal key={p.id} delay={(i % 3) * 0.1}>
                  <Link
                    to={`/resources/${p.slug}`}
                    data-testid={`blog-card-${p.slug}`}
                    className="group block h-full rounded-3xl bg-white border border-line overflow-hidden shadow-[0_8px_30px_rgb(0,0,0,0.04)] hover:shadow-[0_20px_40px_rgb(0,0,0,0.08)] transition-shadow duration-500"
                  >
                    <div className="h-52 overflow-hidden">
                      <img src={p.cover_image} alt={p.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                    </div>
                    <div className="p-7">
                      <div className="flex items-center gap-3 text-xs uppercase tracking-[0.15em] text-terracotta mb-3">
                        <span>{p.category}</span>
                        <span className="flex items-center gap-1 text-ink2"><Clock className="w-3 h-3" /> {p.read_minutes} min</span>
                      </div>
                      <h2 className="font-serif text-2xl text-forest leading-tight group-hover:text-terracotta transition-colors">{p.title}</h2>
                      <p className="mt-3 text-ink2 leading-relaxed line-clamp-3">{p.excerpt}</p>
                      <span className="mt-5 inline-flex items-center gap-1 text-forest font-semibold text-sm">
                        Read article <ArrowUpRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                      </span>
                    </div>
                  </Link>
                </Reveal>
              ))}
            </div>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Blog;
